import { queryOptions } from "@tanstack/react-query";
import { type MenuResponse } from "@da-web/common";

export const menusQueryOptions = queryOptions({
  queryKey: ["menus"],
  queryFn: async () => {
    const res = await fetch(
      `${import.meta.env.VITE_API_BASE_URL ?? ""}/mock/api/menu`
    );
    const menus: MenuResponse = await res.json();
    return menus.message.menu_product_list_page.menu_category;
  },
});
